export default {
  computed: {
    stateOptions () {
      return [
        { id: 'Australian Capital Territory', text: 'ACT' },
        { id: 'New South Wales', text: 'NSW' },
        { id: 'Northern Territory', text: 'NT' },
        { id: 'Queensland', text: 'QLD' },
        { id: 'South Australia', text: 'SA' },
        { id: 'Tasmania', text: 'TAS' },
        { id: 'Victoria', text: 'VIC' },
        { id: 'Western Australia', text: 'WA' }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/states.js